






import Vue from 'vue'

interface CProps {
  html: string | null
}

export default Vue.extend<{}, {}, {}, CProps>({
  name: 'Gallery',
  props: {
    html: String
  }
})
